const BASE_URL = process.env.REACT_APP_API_BASE_URL; 

//Function for Calling Get Widget Tempate Detail API from Frontend
export const getWidgetTemplateDetail = async (isWidgetId) => {
    try {
        const response = await fetch(`${BASE_URL}/widget-template-detail?widget_id=${isWidgetId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

//Function for Calling Get Single Widget Detail API from Frontend
export const getSingleWidgetDetail = async (isWidgetId) => {
    try {
        const response = await fetch(`${BASE_URL}/get-widget-detail?widget_id=${isWidgetId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};